import { Action } from '@ngrx/store';
import { User } from '../../../models/user.model';


export enum ActionType {

  ADD_USER = 'ADD_USER',
  ADD_USER_SUCCESS = 'ADD_USER SUCCESS',
  ADD_USER_FAILED = 'ADD_USER FAILED',
  DELETE_USER = 'DELETE_USER',
  DELETE_USER_SUCCESS = 'DELETE_USER SUCCESS',
  DELETE_USER_FAILED = 'DELETE_USER FAILED',
  FETCH_USERS = 'FETCH USERS',
  FETCH_USERS_SUCCESS = 'FETCH USERS SUCCESS',
  FETCH_USERS_FAILED = 'FETCH USERS FAILED',
  UPDATE_USER = 'UPDATE USER',
  UPDATE_USER_SUCCESS = 'UPDATE USER SUCCESS',
  UPDATE_USER_FAILED = 'UPDATE USER FAILED',
  FETCH_USER = 'FETCH USER',
  FETCH_USER_SUCCESS = 'FETCH USER SUCCESS',
  FETCH_USER_FAILED = 'FETCH USER FAILED',
  UPLOAD_COMPLETED = '[File Upload API] Completed',
  FETCH_USERS_BY_COMPANYID = 'FETCH USERS BY COMPANYID',
  FETCH_USERS_BY_COMPANYID_SUCCESS = 'FETCH USERS BY COMPANYID SUCCESS',
  FETCH_USERS_BY_COMPANYID_FAILED = 'FETCH USERS BY COMPANYID FAILED',


}


export class FetchUsersByCompanyId implements Action {
  readonly type = ActionType.FETCH_USERS_BY_COMPANYID;
  constructor(public companyId: string) { }
}

export class FetchUsersByCompanyIdSuccess implements Action {
  readonly type = ActionType.FETCH_USERS_BY_COMPANYID_SUCCESS;
  constructor(public users: User[]) { }
}

export class FetchUsersByCompanyIdFailed implements Action {
  readonly type = ActionType.FETCH_USERS_BY_COMPANYID_FAILED;
  constructor(public error: any) { }
}

export class UploadCompletedAction implements Action {
  readonly type = ActionType.UPLOAD_COMPLETED;
}


export class FetchUsers implements Action {
  readonly type = ActionType.FETCH_USERS;
  constructor() { }
}

export class FetchUsersSuccess implements Action {
  readonly type = ActionType.FETCH_USERS_SUCCESS;
  constructor(public user: User[]) { }
}

export class FetchUsersFailed implements Action {
  readonly type = ActionType.FETCH_USERS_FAILED;
  constructor(public error: any) { }
}

export class FetchUser implements Action {
  readonly type = ActionType.FETCH_USER;
  constructor(public userId: string) { }
}

export class FetchUserSuccess implements Action {
  readonly type = ActionType.FETCH_USER_SUCCESS;
  constructor(public user: User) { }
}

export class FetchUserFailed implements Action {
  readonly type = ActionType.FETCH_USER_FAILED;
  constructor(public error: any) { }
}

export class AddUser implements Action {
  readonly type = ActionType.ADD_USER;

  constructor(public user: User) { console.log('user', user); }
}

export class AddUserSuccess implements Action {
  readonly type = ActionType.ADD_USER_SUCCESS;

  constructor(public user: User) { }
}

export class AddUserFailed implements Action {
  readonly type = ActionType.ADD_USER_FAILED;

  constructor() { }
}

export class DeleteUser implements Action {
  readonly type = ActionType.DELETE_USER;

  constructor(public id: string) { }
}

export class DeleteUserSuccess implements Action {
  readonly type = ActionType.DELETE_USER_SUCCESS;

  constructor(public id: number) { }
}

export class DeleteUserFailed implements Action {
  readonly type = ActionType.DELETE_USER_FAILED;

  constructor() { }
}

export class UpdateUser implements Action {
  readonly type = ActionType.UPDATE_USER;

  constructor(public user: User) {
    console.log('useruseruser', user);
  }
}

export class UpdateUserSuccess implements Action {
  readonly type = ActionType.UPDATE_USER_SUCCESS;

  constructor(
    public id: string,
    public changes: Partial<User>,
  ) { console.log('changes', changes); }
}

export class UpdateUserFailed implements Action {
  readonly type = ActionType.UPDATE_USER_FAILED;

  constructor() { }
}

export type UserActions =
  AddUser | AddUserFailed | AddUserSuccess |
  UpdateUser | UpdateUserSuccess | UpdateUserFailed |
  DeleteUser | DeleteUserSuccess | DeleteUserFailed |
  FetchUsers | FetchUsersSuccess | FetchUsersFailed |
  FetchUser | FetchUserSuccess | FetchUserFailed |
  FetchUsersByCompanyId | FetchUsersByCompanyIdSuccess | FetchUsersByCompanyIdFailed |
  UploadCompletedAction;



